import { render, staticRenderFns } from "./Consult.vue?vue&type=template&id=a5a92a2a&scoped=true&"
import script from "./Consult.vue?vue&type=script&lang=js&"
export * from "./Consult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a92a2a",
  null
  
)

export default component.exports